import React from 'react';
import { makeObservable, observable, action, computed, runInAction } from 'mobx';

export default class CommentCardViewModel {
  @observable id;
  @observable user = {
    id: 0,
    nickname: 'ted',
    avatar: ''
  };
  @observable commentChapter = {
    id: 0,
    name: '',
    type: '',
    isTrial: false
  };
  @observable createdAt;
  @observable comment;
  @observable reply;
  @observable repliedAt;
  rightRef = React.createRef();
  officialRef = React.createRef();
  @observable isOverflow = false;
  @observable overflowOpen = false;

  @observable isOfficialOverflow = false;
  @observable officialOverflowOpen = false;

  constructor(data) {
    makeObservable(this);

    this.deserialize(data);
  }

  @action
  deserialize = (data) => {
    const {
      id,
      user,
      chapter,
      createdAt,
      comment,
      reply,
      repliedAt
    } = data;

    this.id = id;
    this.user = user;
    this.commentChapter = chapter;
    this.createdAt = createdAt;
    this.comment = comment;
    this.reply = reply;
    this.repliedAt = repliedAt;

  }

  @action
  didMount = () => {
    this.checkForOverflow();
    this.checkOfficialOverflow();
  }

  @action
  checkForOverflow = () => {
    setTimeout(() => {
      if (this.rightRef.current.clientHeight < this.rightRef.current.scrollHeight) {
        runInAction(() => {
          this.isOverflow = true;
        });
      } else {
        runInAction(() => {
          this.isOverflow = false;
        });
      }
    }, 1);
  }

  @action checkOfficialOverflow = () => {
    if (!this.officialRef.current) {
      return;
    }
    setTimeout(() => {
      if (this.officialRef.current.clientHeight < this.officialRef.current.scrollHeight) {
        runInAction(() => {
          this.isOfficialOverflow = true;
        });
      } else {
        runInAction(() => {
          this.isOfficialOverflow = false;
        });
      }
    }, 1);
  }

  @action
  onOverflowClick = () => {
    this.changeOverflow();
  }

  @action
  changeOverflow = () => {
    this.overflowOpen = true;
  }

  @action onOfficialOverflowCLick = () => {
    this.officialOverflowOpen = true;
  }

  @computed
  get fullTitle() {
    return `${this.commentChapter.order ?? ''}${this.commentChapter.name}`;
  }

  @computed
  get modalInfo() {
    return {
      id: this.id,
      chapter: {
        id: this.commentChapter.id,
        name: this.commentChapter.name
      },
      comment: this.comment
    };
  }
}
